// extracted by mini-css-extract-plugin
export default {"paginationWithPageSizeContainer":"PaginationWithPageSize_paginationWithPageSizeContainer__-cmfn","pageSizeSelectContainer":"PaginationWithPageSize_pageSizeSelectContainer__YypGz"};